function Toast($filter, toastr) {
	'ngInject';

	const service = {
		'success': success,
		'error': error,
		'warning': warning,
		'info': info,
		'responseError': responseError
	};

	return service;

	function success(message, title = '') {
		toastr.success(`<i class="fa fa-check-circle toast-icon"></i> ${message}`, title);
	}

	function error(message, title = '') {
		toastr.error(`<i class="fa fa-times-circle toast-icon"></i> ${message}`, title);
	}

	function warning(message, title = '') {
		toastr.warning(`<i class="fa fa-exclamation-circle toast-icon"></i> ${message}`, title);
	}

	function info(message, title = '') {
		toastr.info(`<i class="fa fa-info-circle toast-icon"></i> ${message}`, title);
	}

	function responseError(errors) {
		const errorsKeys = Object.keys(errors);

		/**
		 * Checks if the error response object is valid
		 * Example:
		 * data: {
		 * 		'errors': {
		 * 				'example_error_key': ['example_error_text'],
		 * 				...
		 * 		}
		 * }
		 */
		if (errorsKeys.length && errors[errorsKeys[0]].length && typeof errors[errorsKeys[0]][0] === 'string') {
			error(errors[errorsKeys[0]][0]);
		} else {
			error($filter('translate')('ERRORS.UNKNOWN_ERROR'));
		}
	}
}

export default Toast;



/** WEBPACK FOOTER **
 ** ./client/components/toast/toast.service.js
 **/